




























import * as JointGoodsBlocks from './blocks'
import { defineClassComponent, useQuery } from '@/hooks'
import {
  getJointGoodsModel,
  JointGoodsModel,
  jointGoodsModelProvider,
} from './model'
import { onMounted, ref } from '@vue/composition-api'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: JointGoodsBlocks,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '套餐详情',
        }))

        // 提供标销数据
        jointGoodsModelProvider.provide(this.jointGoodsModel as any)

        onMounted(async () => {
          // 获取标销商品数据
          this.jointGoodsModel.value = (await getJointGoodsModel(
            this.query.goodsId,
          )) as any
          this.loading.value = false

          Track.pushEvent({
            type: 'load',
            name: '浏览商品详情页',
            id: 'LiuLanShangPinXiangQing',
            extra: {
              commodity_source: Track.getFrom(),
              commodity_id: this.jointGoodsModel.value.commodityId,
              commodity_name: this.jointGoodsModel.value.commodityTitle,
              commodity_tag: '',
              original_price: this.jointGoodsModel.value.dashPrice,
              present_price: this.jointGoodsModel.value.lowestPrice,
              discount_price:
                this.jointGoodsModel.value.dashPrice -
                this.jointGoodsModel.value.lowestPrice,
              store_id: this.jointGoodsModel.value.merchantId,
              store_name: this.jointGoodsModel.value.merchantName,
            },
          })
        })
      }

      query = useQuery<{
        goodsId: string
      }>()

      // 是否加载中
      loading = ref(true)

      // 标销商品数据
      jointGoodsModel = ref<JointGoodsModel>({} as any)
    },
)
